import React from 'react';
import styled from '@emotion/styled';

import { rem } from '../utilities/style';
import { media } from '../theme/media';

// These match the heights and breakpoints of the navbar in navbar/Navbar.js
const OffsetElement = styled.div`
  position: relative;
  top: ${rem(-56)};

  ${media('>small')} {
    top: ${rem(-70)};
  }

  ${media('>nav')} {
    top: ${rem(-90)};
  }

`;

const AnchorElement = ({ children, id }) => (
  <>
    <OffsetElement id={id} />
    {children}
  </>
);

export default AnchorElement;
